<template>
  <ui-popover root-class="rd-menu" panel-class="rd-pop--menu" :label="label">
    <template #trigger="{ attrs, on }">
      <button
        type="button"
        class="ui-btn"
        :class="{ 'ui-btn--accent': partial }"
        v-bind="attrs"
        :aria-label="`${label}: ${current ? current.label : ''}`"
        :title="label"
        :disabled="!items.length"
        v-on="on"
      >
        <v-icon size="16">{{ icon }}</v-icon>
        <span class="rd-menu__label">{{ current ? current.label : label }}</span>
        <b v-if="current && current.count != null" class="rd-num">{{ current.count }}</b>
        <v-icon size="16">mdi-chevron-down</v-icon>
      </button>
    </template>

    <template #default="{ close }">
      <div class="rd-pop__head">
        <span>{{ label }}</span>
      </div>
      <div class="rd-checklist" role="radiogroup" :aria-label="label">
        <label v-for="item in items" :key="item.value">
          <input type="radio" :name="name" :checked="item.value === value" @change="pick(item.value, close)" />
          <span :title="item.label">{{ item.label }}</span>
          <span v-if="item.count != null" class="rd-muted rd-num rd-checklist__n">{{ item.count }}</span>
        </label>
      </div>
    </template>
  </ui-popover>
</template>

<script>
/**
 * Dugme sa iskačućim izborom jedne vrednosti u traci filtera (npr. status porudžbe). Ne drži izbor: dobija `value` i
 * `items` ([{ value, label, count }], broj je opcion) i javlja `input`. Dugme je u boji kad izbor nije prvi u spisku
 * (podrazumevani), a izbor se zatvara čim se vrednost izabere.
 */
export default {
  name: "ReportChoiceMenu",
  props: {
    label: { type: String, required: true },
    items: { type: Array, default: () => [] },
    value: { type: [Number, String], default: null },
    icon: { type: String, default: "mdi-filter-variant" },
    name: { type: String, default: "rd-choice" },
  },
  computed: {
    current() {
      return this.items.find((item) => item.value === this.value) || null;
    },
    partial() {
      return this.items.length > 0 && this.value !== this.items[0].value;
    },
  },
  methods: {
    pick(value, close) {
      this.$emit("input", value);
      close(true);
    },
  },
};
</script>
